export default {
  THANK_YOU_MESSAGE: 'thankYouMessage',
  REDIRECT_PAGE: 'redirectPage',
  MEETING_REDIRECT: 'meetingRedirect',
  CONDITIONAL_REDIRECT: 'conditionalRedirect'
};